import styled from 'styled-components';
import { Spin } from 'antd';

export const Spinner = styled(Spin)``;
